import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createBrowserRouter, RouterProvider, Navigate, Outlet } from "react-router-dom";

import "./styles/global.css";
import "./i18n.tsx";
import LoginView from "./views/Login/index.tsx";
import HomeView from "./views/Home/index.tsx";
import { LoginContextProvider } from "./views/Login/Login.context.tsx";
import { HomeContextProvider } from "./views/Home/HomeView.context.tsx";
import { ThemeProvider } from "./context/Theme.context.tsx";
import { clearToken, hasValidSession } from "./services/auth.utils.tsx";

/**
 * Solo entra quien tiene sesión **utilizable**, no solo un token guardado.
 *
 * Comprobar únicamente que existiera dejaba abrir `/home` con la sesión caducada: la pantalla
 * cargaba, se podía interactuar, y el error aparecía mucho después. El token se borra al pasar por
 * aquí para que no vuelva a colar en la siguiente carga.
 */
export const ProtectedRoute = () => {
  if (!hasValidSession()) {
    clearToken();
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <LoginContextProvider>
        <LoginView />
      </LoginContextProvider>
    ),
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/home",
        element: (
          <HomeContextProvider>
            <HomeView />
          </HomeContextProvider>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <div>404 - Página no encontrada</div>,
  },
]);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("No se encontró el elemento root en el DOM");
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>
);
